// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getLicenseObligationData} from "../../../ExternalData/License/LicenseClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationLicenseGrid() {


    // ****************** BEGIN STATES ****************************

    const [licenseData, setLicenseData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    // ****************** BEGIN FETCH ****************************

    const fetchLicenseData = () =>
        getLicenseObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setLicenseData(data);
                console.log("This is my data used for the grid rows...");
                console.log(licenseData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My license grid should have displayed...");
        fetchLicenseData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.licenseGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({licenseGridOpen: false}));
    };


    function closeLicenseDataDrawer() {
        dispatchData(changeObligationHierarchy({licenseGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchLicenseData => [

        {    field: 'licenseId',
            headerName: 'External ID',
            description: '',
            sortable: false,
            width: 90,
            hide: false,
        },
        {    field: 'licensee',
            headerName: 'Licensee',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'displayAmount',
            headerName: 'Amount',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
            align: "right"
        },
        {    field: 'executionDate',
            headerName: 'Executed',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'availBegin',
            headerName: 'Begin',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'availEnd',
            headerName: 'End',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'licenseTerritory',
            headerName: 'Territory',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'licensedRuns',
            headerName: 'Runs',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'exhibitionDays',
            headerName: 'Days',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>

                    <GridToolbarColumnsButton />
                    {/*<GridToolbarFilterButton sx={{mr: 3}} />*/}
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer sx={{height: "100%", width: 1000}}
                    anchor='right'
                // open={true}
                    open={useSelector((state) => state.obligationHierarchySlc.value.licenseGridOpen)}
                // initialState={{open: false}}
                    onClose={closeLicenseDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>License Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro

                            style={{height: 600, width: 1000}}
                            aria-label={"LicenseDataDrawerGrid"}
                            rows={licenseData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}

                            columns={columns(fetchLicenseData)}

                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}

                            rowThreshold={0}

                            components={{
                                Toolbar: CustomToolbar,
                            }}

                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************


}
